var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgIconBio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#CEDCFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#4974D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.333 24.6663V21.9997C19.333 21.2924 19.614 20.6142 20.1141 20.1141C20.6142 19.614 21.2924 19.333 21.9997 19.333H24.6663M19.333 35.333V37.9997C19.333 38.7069 19.614 39.3852 20.1141 39.8853C20.6142 40.3854 21.2924 40.6663 21.9997 40.6663H24.6663M35.333 19.333H37.9997C38.7069 19.333 39.3852 19.614 39.8853 20.1141C40.3854 20.6142 40.6663 21.2924 40.6663 21.9997V24.6663M35.333 40.6663H37.9997C38.7069 40.6663 39.3852 40.3854 39.8853 39.8853C40.3854 39.3852 40.6663 38.7069 40.6663 37.9997V35.333M26.6663 33.9997C27.1008 34.4431 27.6195 34.7954 28.1918 35.036C28.7642 35.2765 29.3788 35.4004 29.9997 35.4004C30.6205 35.4004 31.2351 35.2765 31.8075 35.036C32.3799 34.7954 32.8985 34.4431 33.333 33.9997",
    stroke: "#F8F8F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27.333H26.0133M34 27.333H34.0133",
    stroke: "#F8F8F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIconBio);
export default __webpack_public_path__ + "static/media/img-icon-bio.87d9e350157cf9d1fa2672d97ba5989d.svg";
export { ForwardRef as ReactComponent };